<div class="dialog">
  @if (isMobileView) {
    <div class="mobile-app-bar right-action-icons-only sticky-header">
      @if (isUserAuthor || isAdmin) {
        <div class="mobile-app-bar__action-icon">
          <app-icon (click)="openEditFaqSheet()" iconName="pencil" size="16px"></app-icon>
        </div>
        <div class="mobile-app-bar__action-icon">
          <app-icon (click)="deleteFaq(currentFaq?.id)" iconName="trash" size="16px"></app-icon>
        </div>
      }
      <div class="mobile-app-bar__action-icon">
        <app-icon (click)="close()" iconName="close" size="16px"></app-icon>
      </div>
    </div>
  }
  @if (!isMobileView) {
    <header class="dialog__header">
      <h3 class="dialog__header__title"></h3>
      <div class="dialog__header__action-buttons">
        @if (isUserAuthor || isAdmin) {
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="openEditFaqDialog()" [cssStyle]="{ margin: '4px' }" iconName="pencil" size="20px"></app-icon>
            </span>
          </div>
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="deleteFaq(currentFaq?.id)" [cssStyle]="{ margin: '4px' }" iconName="trash-bin" size="20px"></app-icon>
            </span>
          </div>
        }
        <div class="dialog__header__action-buttons__button">
          <span>
            <app-icon (click)="close()" [cssStyle]="{ margin: '4px' }" iconName="close" size="20px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    @if (!isLoading && currentFaq.title) {
      @if (alertType) {
        <app-alert-message [alertType]="alertType" [denyReason]="currentFaq.denyReason" [showCloseIcon]="false" [size]="'small'"></app-alert-message>
      }

      @if (currentFaq?.image) {
        <div class="faq-image background-loading">
          <img [src]="currentFaq?.imageUrl" alt="{{ currentFaq?.title }}" appDefaultImage="assets/images/defaults/" lazy="true" loading="lazy" />
        </div>
      }

      <div class="flex-row-between-center flex-nowrap mt-25">
        <h5 class="faq-title">{{ currentFaq.title }}</h5>
      </div>
      @if (!isLoading) {
        <article [innerHTML]="currentFaq?.description" class="faq-text">{{ currentFaq?.description }}</article>
      } @else {
        <ngx-skeleton-loader
          [theme]="{
            height: '300px',
          }"
          count="1"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [theme]="{
            height: '30px',
          }"
          count="1"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [theme]="{
            height: '100px',
          }"
          count="1"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [theme]="{
            height: '30px',
          }"
          count="1"
        ></ngx-skeleton-loader>
      }

      @if (currentFaq.document && !currentFaq.image) {
        <div class="mt-20">
          <app-button (clickEvent)="downloadDocument(currentFaq, $event)" [idleText]="currentFaq.document" [prefixIconName]="'download'" iconColor="var(--white)" iconSize="16px"></app-button>
        </div>
      }
    } @else {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
    }
  </div>
</div>

<ng-template #loader>
  <ngx-skeleton-loader
    [theme]="{
      height: '300px',
    }"
    count="1"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    [theme]="{
      height: '30px',
    }"
    count="1"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    [theme]="{
      height: '100px',
    }"
    count="1"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    [theme]="{
      height: '30px',
    }"
    count="1"
  ></ngx-skeleton-loader>
</ng-template>
